import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import _ from 'underscore';

import config from './../config';

import AutocompleteInput from './AutocompleteInput';

class SearchOverlay extends Component {
	constructor(props) {
		super(props);

		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.searchBoxItemSelectHandler = this.searchBoxItemSelectHandler.bind(this);
		this.executeSearch = this.executeSearch.bind(this);
		this.listItemFormat = this.listItemFormat.bind(this);

		this.state = {
			searchBoxInput: ''
		};
	}

	componentDidMount() {
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.visible != prevProps.visible && this.props.visible) {
			this.setState({
				searchBoxInput: ''
			});

			this.refs.searchInput.refs.inputField.focus();
		}
	}

	inputChangeHandler(event) {
		var stateObj = {};

		stateObj[event.target.name] = event.target.value;

		this.setState(stateObj);
	}

	searchBoxItemSelectHandler(item) {
		this.props.history.push('/nyyrdi/'+item.id);

		if (this.props.onSearch) {
			this.props.onSearch();
		}
	}

	listItemFormat(item) {
		return <div>
			<strong>{item.ord}</strong>
			{
				item.skyringar && item.skyringar.length > 0 &&
				<React.Fragment>
					<br/>
					{item.skyringar[0].merking}
				</React.Fragment>
			}
		</div>
	}

	executeSearch() {
		this.props.history.push('/leit/'+this.state.searchBoxInput);

		if (this.props.onSearch) {
			this.props.onSearch();
		}
	}

	render() {
		return (
			<div className={'search-overlay'+(this.props.visible ? ' visible' : '')}>
				<button className="close-button" onClick={function() {
						if (this.props.onClose) {
							this.props.onClose();
						}
					}.bind(this)}></button>

				<div className="overlay-content">
					<h3>Leit að nýyrði</h3>
					<AutocompleteInput inputClassName="form-control" 
						ref="searchInput"
						responseDataField="results"
						searchUrl={config.apiRoot+'/api/nyyrdi/?search=$s&limit=10'}
						onChange={this.inputChangeHandler} 
						inputName="searchBoxInput" 
						value={this.state.searchBoxInput} 
						valueField="nyyrdi"
						type="text" 
						onEnter={this.executeSearch} 
						onItemSelect={this.searchBoxItemSelectHandler}
						placeholder="Skrifaðu leitarorð"
						minChars={1}
						selectedItemClass="active"
						//disableAutoFill={true} 
						headerText="Veldu nýyrði úr lista eða ýttu á enter til að leita."
						listLabelFormatFunc={this.listItemFormat}
						dataFormatFunc={function(data) {
							return _.uniq(data, function(item) {
								return item.id
							});
						}} />
				</div>

			</div>
		);
	}
}

export default withRouter(SearchOverlay);



// WEBPACK FOOTER //
// ./src/components/SearchOverlay.js